import React from "react";
import { useTranslation } from "react-i18next";
import {
  StyledModalBody,
  StyledModal,
  StyledModalFooter,
} from "../styledComponents/StyledModals";
import { StyledButton } from "../styledComponents/CommonStyledComponents";
import { toast } from "react-toastify";
import { useApolloClient } from "@apollo/client";
import { MUTATION_LOW_RISK_SCORE_CONFIRM } from "../graphql/mutations";

export const LowRiskScoreDialog = ({
  showModal,
  setLowRiskScoreDialog,
  skin,
}) => {
  const { t } = useTranslation("");
  const apolloClient = useApolloClient();

  return (
    <StyledModal isOpen={showModal}>
      <StyledModalBody
        register
        dangerouslySetInnerHTML={{
          __html: t("label_responsible_gaming_event_rglrs_triggered"),
        }}
      ></StyledModalBody>
      <StyledModalFooter position>
        <StyledButton
          banktransfer
          pub={skin === "pub"}
          onClick={() => setLowRiskScoreDialog(false)}
        >
          {t("label_ok", "Ok")}
        </StyledButton>
      </StyledModalFooter>
    </StyledModal>
  );
};
